var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/payment_method.68faeae0.png","uri@2x": __webpack_public_path__ + "static/media/payment_method.79d943e5.png","uri@3x": __webpack_public_path__ + "static/media/payment_method.bcd3f836.png",
    width: 42,
    height: 42
});